import React from "react";

export default function UpdateSVG() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className="w-6 h-6 cursor-pointer transition-all"
    >
      <path
        d="M19.364 5.636a2 2 0 0 0-2.828 0L5.636 16.536a1 1 0 0 0-.276.455l-1.263 4.209a1 1 0 0 0 1.219 1.219l4.209-1.263a1 1 0 0 0 .455-.276l10.9-10.9a2 2 0 0 0 0-2.828zM7.74 17.739l-2.015.605.606-2.016L14.3 6.699l1.414 1.414L7.74 17.739zm10.779-10.778L15.114 7.16l1.414 1.414 3.385-3.385a1 1 0 0 0 0-1.414l-1.414-1.414a1 1 0 0 0-1.414 0l-3.385 3.385 1.414 1.414z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
